<div class="list-page" style="padding-bottom: 20px">
  <app-asiakas-otsikko otsikko="Asetukset, kirjanpito" paluuUrl="/asiakkaat" [asiakas]="asiakas"></app-asiakas-otsikko>

  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div style="padding-bottom: 20px">
      <h3 style="margin: 0">Urit</h3>
      <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
        Asiakas: <a [href]="asiakasEncodedUriObservable | async" target="_BLANK">{{ asiakasUriObservable | async }}</a>
      </div>
    </div>
  }

  <form>
    <div class="light-blue-text header">Perustiedot</div>
    <div class="content" style="max-width: 550px">
      <div style="display: flex; justify-content: start; flex-flow: row; align-items: center">
        <mat-form-field style="max-width: 180px; margin-right: 10px">
          <mat-label>Yritysmuoto</mat-label>
          <mat-select [formField]="lomake.yritysmuoto">
            @for (yritysmuoto of yritysmuodot; track yritysmuoto) {
              <mat-option [value]="yritysmuoto.koodi">
                {{ yritysmuoto.nimi }}
              </mat-option>
            }
          </mat-select>
          @if (naytetaankoVirhe(lomake.yritysmuoto, 'required')) {
            <mat-error> Yritysmuoto puuttuu </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="light-blue-text header">Työlista</div>
    <div class="content" style="max-width: 550px">
      <div style="transform: scale(0.9); transform-origin: center left">
        <mat-radio-group [formField]="lomake.lista">
          <mat-radio-button [value]="false">Näytä Fivaldin listalla</mat-radio-button><br />
          <mat-radio-button [value]="true">Näytä Työlistalla</mat-radio-button>
        </mat-radio-group>
        <div class="gray-text" style="font-size: 11px; margin-top: 6px">Kasvu-asiakkaat menevät aina Kasvu-listaan, valinnasta huolimatta.</div>
      </div>

      <!-- <mat-form-field style="max-width: 240px; margin-left: 20px;">
      <input matInput monthPicker type="text" [matDatepicker]="uudessaListassaAlkaenPicker" formControlName="uudessaListassaAlkaen" placeholder="Kirjanpito Lemonatorissa alkaen" required>
      <mat-datepicker-toggle matSuffix [for]="uudessaListassaAlkaenPicker"></mat-datepicker-toggle>
    </mat-form-field>
    <mat-datepicker #uudessaListassaAlkaenPicker></mat-datepicker> -->

      <div style="font-weight: bold; font-size: 110%; margin-bottom: 10px; margin-top: 30px; margin-left: 5px">Aktiiviset kuukausiruudut</div>

      <div style="max-width: 560px">
        @for (kausi of lomake.kkruutukaudet; track kausi; let i = $index) {
          <div>
            <div style="display: flex; justify-content: space-between; padding-top: 15px">
              <mat-form-field style="max-width: 280px; margin-left: 10px; margin-right: 10px">
                <mat-label>Ensimmäinen tehtävä kuukausi</mat-label>
                <input #kkruutukausiAlkaaInput type="text" [matDatepicker]="kkruutuAlkaaPicker" [formField]="kausi.alkaa" matInput data-lpignore="true" />
                <mat-datepicker-toggle matSuffix [for]="kkruutuAlkaaPicker"></mat-datepicker-toggle>
                @if (naytetaankoVirhe(kausi.alkaa, 'required')) {
                  <mat-error> Päivämäärä puuttuu </mat-error>
                }
                @if (naytetaankoVirhe(kausi.alkaa, 'edellinen')) {
                  <mat-error> Muutos ei voi olla samaan aikaan tai ennen edellistä kautta. </mat-error>
                }
                @if (naytetaankoVirhe(kausi.alkaa, 'loppuEnnenAlkua')) {
                  <mat-error> On loputtava alkamisen jälkeen. </mat-error>
                }
                @if (naytetaankoVirhe(kausi.alkaa, 'alkuEnnenEdellisenLoppua')) {
                  <mat-error> Alettava myöhemmin kuin edellinen loppuu </mat-error>
                }
                <mat-datepicker #kkruutuAlkaaPicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field style="max-width: 280px; margin-left: 10px; margin-right: 10px">
                <mat-label>Viimeinen tehtävä kuukausi</mat-label>
                <input type="text" [matDatepicker]="kkruutuLoppuuPicker" [formField]="kausi.loppuu" matInput data-lpignore="true" />
                <mat-datepicker-toggle matSuffix [for]="kkruutuLoppuuPicker"></mat-datepicker-toggle>
                @if (naytetaankoVirhe(kausi.loppuu, 'required')) {
                  <mat-error> Päivämäärä puuttuu </mat-error>
                }
                @if (naytetaankoVirhe(kausi.loppuu, 'loppuEnnenAlkua')) {
                  <mat-error> On loputtava alkamisen jälkeen. </mat-error>
                }
                @if (naytetaankoVirhe(kausi.loppuu, 'loppuuPuuttuu')) {
                  <mat-error> Merkitse loppu </mat-error>
                }
                <mat-datepicker #kkruutuLoppuuPicker></mat-datepicker>
              </mat-form-field>
              <app-icon-button (click)="poistaKkruutujakso(kausi)" actionId="Poista kuukausiruutu jakso" additionalClass="secondarybutton mat-elevation-z4" styles="padding:0;" matIcon="delete_forever"> </app-icon-button>
            </div>
          </div>
        }
      </div>

      @if (naytetaankoVirhe(lomake.kkruutukaudet, 'min')) {
        <mat-error style="padding-top: 15px; margin-left: 10px"> Ole hyvä ja syötä vähintään yksi kausi. </mat-error>
      }

      @if (kkruutuError) {
        <mat-error style="padding-top: 15px; margin-left: 10px">
          {{ kkruutuError }}
        </mat-error>
      }

      <div style="padding-top: 15px; margin-left: 10px; padding-bottom: 1.25em">
        <app-secondary-button (click)="lisaaKkruutujakso()" actionId="Avattu muokkausnäkymä: Lisää työlistakausi rivi" additionalClass="mat-elevation-z4" matIcon="add"> Lisää työlistakausi </app-secondary-button>
      </div>
    </div>

    <!-- {{ viimeisinAlvIlmoitusObservable | async | json }} -->
    <!-- valid: {{form.valid}}, invalid: {{form.invalid}} -->

    <div class="light-blue-text header">
      ALV-ilmoitusjaksot
      @if (punakynaCanBeUsedObservable | async) {
        <app-icon-button (click)="toggleMuokkaaMitaVain()" title="Muokkaa mitä tahansa arvoa" actionId="Avaa punakynä, muokkaa mitä tahansa ALV-ilmoitusjakson arvoa">
          <span class="fa fa-pencil" [class.red-text]="punakynaActiveSubject | async"></span>
        </app-icon-button>
      }
    </div>
    <div class="content">
      <div style="display: flex">
        <div style="max-width: 450px">
          @for (jakso of lomake.alvIlmoitusjaksot; track jakso; let i = $index) {
            <div>
              <div style="display: flex; justify-content: space-between">
                <mat-form-field style="max-width: 180px; margin-left: 10px; margin-right: 10px">
                  <mat-label>ALV-ilmoitusjakso</mat-label>
                  <mat-select #alvIlmoitusjaksoSelect [formField]="jakso.jakso">
                    <!-- <mat-option [value]="null">
                  Valitse jakso
                </mat-option> -->
                    @for (jakso of alvIlmoitusjaksot; track jakso) {
                      <mat-option [value]="jakso.koodi">
                        {{ jakso.nimi }}
                      </mat-option>
                    }
                  </mat-select>
                  <mat-error>
                    @if (jakso.jakso().dirty() || jakso.jakso().touched()) {
                      @if (onkoVirhe(jakso.jakso, 'samajakso')) {
                        Jakso ei voi olla sama kuin edellinen.
                      }
                    }
                  </mat-error>
                </mat-form-field>
                <mat-form-field style="max-width: 150px; margin-left: 10px; margin-right: 10px">
                  <mat-label>Voimassa alkaen</mat-label>
                  <input matInput monthPicker #monthPicker type="text" [matDatepicker]="alvIlmoitusPicker" [formField]="jakso.voimassaAlkaen" />
                  <mat-datepicker-toggle matSuffix [for]="alvIlmoitusPicker"></mat-datepicker-toggle>
                  @if (naytetaankoVirhe(jakso.voimassaAlkaen, 'required')) {
                    <mat-error>Kuukausi puuttuu</mat-error>
                  }
                  @if (naytetaankoVirhe(jakso.voimassaAlkaen, 'edellinen')) {
                    <mat-error>Muutos ei voi olla samaan aikaan tai ennen edellistä muutosta.</mat-error>
                  }
                  @if (naytetaankoVirhe(jakso.voimassaAlkaen, 'min')) {
                    <mat-error>Uusi muutos voi alkaa aikaisintaan {{ minimumAllowedDate | ldate | async }}.</mat-error>
                  }
                  @if (naytetaankoVirhe(jakso.voimassaAlkaen, 'matDatepickerMin')) {
                    <mat-error>Uusi muutos voi alkaa aikaisintaan ensi kuussa.</mat-error>
                  }
                  @if (naytetaankoVirhe(jakso.voimassaAlkaen, 'a1_or_3_to12')) {
                    <mat-error>Jakson vaihto pidempään on alettava tammikuussa.</mat-error>
                  }
                  @if (naytetaankoVirhe(jakso.voimassaAlkaen, 'b1_or_3_to12')) {
                    <mat-error>12kk jaksoon siirtyminen voi tapahtua vain seuraavan vuoden tammikuussa.</mat-error>
                  }
                  @if (naytetaankoVirhe(jakso.voimassaAlkaen, 'a12_to_3')) {
                    <mat-error>12kk jakso voidaan muuttaa 3kk jaksoksi aikaisintaan seuraavana tammi-, huhti-, heinä- tai marraskuuna.</mat-error>
                  }
                  @if (naytetaankoVirhe(jakso.voimassaAlkaen, 'b12_to_3')) {
                    <mat-error>12kk jälkeen tuleva 3kk jakson on alettava tammi-, huhti-, heinä- tai marraskuussa.</mat-error>
                  }
                  @if (naytetaankoVirhe(jakso.voimassaAlkaen, 'a1_to_3')) {
                    <mat-error>1kk jakso voidaan muuttaa 3kk jaksoksi aikaisintaan seuraavana tammi-, huhti-, heinä- tai marraskuuna.</mat-error>
                  }
                  @if (naytetaankoVirhe(jakso.voimassaAlkaen, 'b1_to_3')) {
                    <mat-error>1kk jälkeen tuleva 3kk jakson on alettava tammi-, huhti-, heinä- tai marraskuussa.</mat-error>
                  }
                  <mat-datepicker #alvIlmoitusPicker></mat-datepicker>
                </mat-form-field>
                <!-- <mat-form-field style="max-width: 400px; margin-left: 10px; margin-right: 10px;">
            <input [name]="namename" type="text" formControlName="syy" placeholder="Muutoksen syy" matInput data-lpignore="true" required />
            <mat-hint *ngIf="jakso.get('syy').enabled">Kerro miksi jakso muuttuu. Jos asiakassuhde loppuu, kerro myös syy lopettamiseen</mat-hint>
            <mat-error *ngIf="jakso.get('syy')?.errors?.required && (jakso.get('syy')?.dirty || jakso.get('syy')?.touched)">
              Muutoksen syy puuttuu
            </mat-error>
          </mat-form-field> -->
                <app-icon-button [disabled]="jakso.jakso().disabled() || 1 > i" (click)="poistaAlvIlmoitusjaksorivi(jakso)" actionId="Poista ALV-ilmoitusjakso rivi" [dynamicClass]="{ 'mat-elevation-z4': !jakso.jakso().disabled() }" additionalClass="secondarybutton" styles="padding:0;" matIcon="delete_forever"> </app-icon-button>
              </div>
            </div>
          }
        </div>

        <div style="margin-left: 80px; max-width: 550px" class="dark-gray-text">
          <div style="font-size: 16px; margin-bottom: 10px; line-height: 20px; margin-top: 40px">Miten ALV-ilmoitusjaksoa on mahdollista muuttaa?</div>
          <div style="margin: 0.5em 0">ALV-jaksoa voi muuttaa vapaasti kunnes ensimmäinen ALV-ilmoitus on lähetetty. Tämän jälkeen muutokset menevät seuraavan taulukon mukaan. Mikäli tarvitset muutoksen jota ei tueta, ilmoita siitä tekniseen tukeen.</div>
          <table>
            <tr>
              <td style="width: 120px; vertical-align: top">12kk -> 3kk</td>
              <td>Aikaisintaan seuraavana tammi-, huhti-, heinä- tai marraskuuna. Kuukauden on aina oltava jokin edellä mainituista.</td>
            </tr>
            <tr>
              <td style="width: 120px; vertical-align: top">12kk -> 1kk</td>
              <td>Aikaisintaan seuraavan kuukauden alusta.</td>
            </tr>
            <tr>
              <td style="width: 120px; vertical-align: top">3kk -> 1kk</td>
              <td>Aikaisintaan seuraavan kuukauden alusta.</td>
            </tr>
            <tr>
              <td style="width: 120px; vertical-align: top">1kk -> 3kk</td>
              <td>Seuraavan kvartaalin alku.</td>
            </tr>
            <tr>
              <td style="width: 120px; vertical-align: top">1kk -> 12kk</td>
              <td>Seuraavan vuoden tammikuu.</td>
            </tr>
            <tr>
              <td style="width: 120px; vertical-align: top">3kk -> 12kk</td>
              <td>Seuraavan vuoden tammikuu.</td>
            </tr>
          </table>
        </div>
      </div>

      @if (naytetaankoVirhe(lomake.alvIlmoitusjaksot, 'min')) {
        <mat-error style="margin-left: 10px"> Ole hyvä ja syötä vähintään yksi jakso. </mat-error>
      }

      <div style="padding-top: 10px; margin-left: 10px; padding-bottom: 1.25em">
        <app-secondary-button (click)="lisaaAlvIlmoitusjaksorivi()" actionId="Avattu muokkausnäkymä: Lisää ALV-ilmoitusjakso rivi" additionalClass="mat-elevation-z4" matIcon="add"> Lisää ALV-ilmoitusjakso </app-secondary-button>
      </div>
    </div>

    <!-- <div class="light-blue-text header">Pankkitilit</div> -->
    <!-- <mat-hint *ngIf="annaTilinumeroControllit().length > 0" style="margin-left: 10px; padding-top: 10px; display: block;">Pankki ja BIC täytetään automaattisesti suomalaisille pankeille IBAN-kentän mukaan</mat-hint> -->
    <!-- <div formArrayName="tilinumerot" style="max-width: 400px;">
<div *ngFor="let tilinumero of annaTilinumeroControllit(); let i = index;" [formGroupName]="i">
  <div style="display: flex; justify-content: space-between; padding-top: 5px;">
    <mat-form-field style="max-width: 300px; margin-left: 10px; margin-right: 10px;">
      <mat-label>{{ 'laskuasetukset.iban' | translate | async }}</mat-label>
      <input [name]="namename" #ibanInput type="text" formControlName="iban"  required matInput data-lpignore="true" />
      <mat-hint>{{pankkiJaIbanTeksti(tilinumero)}}</mat-hint>
      <mat-error *ngIf="tilinumero.get('iban')?.errors?.required && (tilinumero.get('iban')?.dirty || tilinumero.get('iban')?.touched)">
        IBAN puuttuu
      </mat-error>
      <mat-error *ngIf="tilinumero.get('iban')?.errors?.iban && (tilinumero.get('iban')?.dirty || tilinumero.get('iban')?.touched)">
        IBAN on virheellinen
      </mat-error>
    </mat-form-field> -->
    <!-- <mat-form-field style="max-width: 125px; margin-left: 10px; margin-right: 10px;">
    <mat-label>{{ 'laskuasetukset.pankki' | translate | async }}</mat-label>
    <input [name]="namename" type="text" formControlName="pankki"  matInput required data-lpignore="true" />
    <mat-error *ngIf="tilinumero.get('pankki')?.errors?.required && (tilinumero.get('pankki')?.dirty || tilinumero.get('pankki')?.touched)">
      Pankki puuttuu
    </mat-error>
  </mat-form-field>
  <mat-form-field style="max-width: 125px; margin-left: 10px; margin-right: 10px;">
    <mat-label>{{ 'laskuasetukset.bic' | translate | async }}</mat-label>
    <input [name]="namename" type="text" formControlName="bic"  matInput required data-lpignore="true" />
    <mat-error *ngIf="tilinumero.get('bic')?.errors?.required && (tilinumero.get('bic')?.dirty || tilinumero.get('bic')?.touched)">
      BIC puuttuu
    </mat-error>
    <mat-error *ngIf="tilinumero.get('bic')?.errors?.bic && (tilinumero.get('bic')?.dirty || tilinumero.get('bic')?.touched)">
      BIC on virheellinen
    </mat-error>
  </mat-form-field> -->
    <!-- <div> -->
    <!-- [disabled]="hinta.get('hinta')?.disabled || 1 > i" -->
    <!-- [class.mat-elevation-z4]="!hinta.get('hinta')?.disabled" -->
    <!-- <button mat-icon-button (click)="poistaTilinumero(tilinumero)" type="button" style="padding:0;" class="secondarybutton mat-elevation-z4">
  <mat-icon>delete_forever</mat-icon>
</button>
</div>
</div>
</div>
</div>

<mat-error *ngIf="annaTilinumerotFormArray()?.errors?.min && (annaTilinumerotFormArray()?.dirty || annaTilinumerotFormArray()?.touched)" style="margin-left: 10px;">
  Ole hyvä ja syötä vähintään yksi pankkitili.
</mat-error> -->

    <!-- <div style="padding-top: 10px; margin-left: 10px; padding-bottom: 1.25em;">
<button mat-button (click)="lisaaTilinumero()" type="button" class="secondarybutton mat-elevation-z4">
  <mat-icon>add</mat-icon>
  Lisää pankkitili
</button>
</div> -->

    <div class="light-blue-text header">Kirjanpitosähköpostien lisävastaanottajat</div>
    <div class="content" style="max-width: 450px">
      <div style="margin-top: 0.5em; margin-bottom: 0.5em; font-style: italic">Käytä tätä ainoastaan yhteissähköposteille, esim. info&#64;firma.fi. Yksityishenkilöille menevät viestit toimitetaan pääsääntöisesti yhteyshenkilö-roolin omaaville Lemonaid-käyttäjille.</div>
      <mat-chip-grid #vastaanottajaChips>
        @for (vastaanottaja of asiakas.kirjanpitoviestienLisavastaanottajat; track vastaanottaja) {
          <mat-chip-option style="margin-top: 15px; margin-left: 10px; margin-bottom: 15px" [selectable]="false" [removable]="true" (removed)="poistaVastaanottaja(vastaanottaja)">
            {{ vastaanottaja }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip-option>
        }
      </mat-chip-grid>
      <mat-form-field style="margin-bottom: 15px; margin-top: 25px">
        <mat-label>Lisää vastaanottaja</mat-label>
        <input #recipientInput type="email" [matChipInputFor]="vastaanottajaChips" (blur)="lisaaVastaanottaja()" [formField]="lomake.vastaanottaja" (matChipInputTokenEnd)="lisaaVastaanottaja()" matInput data-lpignore="true" class="email-lisaa-vastaanottaja" />
        @if (naytetaankoVirhe(lomake.vastaanottaja, 'email')) {
          <mat-error> Sähköpostiosoite on virheellinen. </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="light-blue-text header">Tilikaudet</div>
    <div class="content">
      <div style="max-width: 550px">
        @for (kausi of lomake.tilikaudet; track kausi; let i = $index) {
          <div>
            <div style="display: flex; justify-content: space-between; padding-top: 5px">
              <!-- <mat-form-field style="max-width: 180px; margin-left: 10px; margin-right: 10px;">
          <mat-label>{{ 'Tilikausi' }}</mat-label>
          <input [name]="namename" type="text" formControlName="kausi"  matInput required data-lpignore="true" />
          <mat-error *ngIf="kausi.get('kausi')?.errors?.required && (kausi.get('kausi')?.dirty || kausi.get('kausi')?.touched)">
            Kausi puuttuu
          </mat-error>
        </mat-form-field> -->
              <mat-form-field style="max-width: 125px; margin-right: 10px">
                <!-- [min]="annaMinimiPaivamaara(hinta.get('voimassaAlkaen'))" -->
                <mat-label>Alkaa</mat-label>
                <input #tilikausiAlkaaInput type="text" [matDatepicker]="alkaaPicker" [formField]="kausi.alkaa" matInput data-lpignore="true" />
                <mat-datepicker-toggle matSuffix [for]="alkaaPicker"></mat-datepicker-toggle>
                @if (naytetaankoVirhe(kausi.alkaa, 'required')) {
                  <mat-error> Päivämäärä puuttuu </mat-error>
                }
                <mat-datepicker #alkaaPicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field style="max-width: 125px; margin-left: 10px; margin-right: 10px">
                <!-- [min]="annaMinimiPaivamaara(hinta.get('voimassaAlkaen'))" -->
                <mat-label>Loppuu</mat-label>
                <input type="text" [matDatepicker]="loppuuPicker" [formField]="kausi.loppuu" matInput data-lpignore="true" />
                <mat-datepicker-toggle matSuffix [for]="loppuuPicker"></mat-datepicker-toggle>
                @if (naytetaankoVirhe(kausi.loppuu, 'required')) {
                  <mat-error> Päivämäärä puuttuu </mat-error>
                }
                <mat-datepicker #loppuuPicker></mat-datepicker>
              </mat-form-field>
              <button mat-button (click)="avaaProfiiliDialogi(i)" [disabled]="kausi.lukittu().value()" style="max-width: 160px; margin-left: 10px; margin-right: 10px; height: 48px">
                {{ annaProfiilinNimi(kausi.tilikartanProfiili().value()) }}
              </button>
              <div style="width: 50px">
                @if (kausi.lukittu().value()) {
                  <app-icon-button (click)="avaaTilikausi(i)" actionId="Avasi dialogin: Avaa tilikausi" [actionContext]="[i]" matIcon="lock" title="Tilikausi on lukittu, eikä sitä voi muokata. Avaa napauttamalla lukkoa"> </app-icon-button>
                } @else {
                  <app-icon-button (click)="lukitseTilikausi(i)" actionId="Avasi dialogin: Lukitse tilikausi" [actionContext]="[i]" matIcon="lock_open" title="Tilikausi on muokattavissa. Lukitse napauttamalla lukkoa"> </app-icon-button>
                }
              </div>
              <div style="width: 50px" [matTooltip]="kausi.synkkausLukittu().value() ? 'Synkronointi lukittu. Tälle tilikaudelle ei ladata enää tilitapahtumia eikä palkkatietoja.' : 'Synkronointi päällä.'">
                <button [disabled]="!onkoDevaajaTaiKayttotuki()" mat-icon-button (click)="kausi.synkkausLukittu().value() ? avaaSynkkaus(i) : lukitseSynkkaus(i)">
                  @if (kausi.synkkausLukittu().value()) {
                    <svg class="sync-locked-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none">
                      <path
                        d="M4.64652 2.14645C4.45126 2.34171 4.45126 2.65829 4.64652 2.85355L5.89652 4.10355C6.09178 4.29882 6.40837 4.29882 6.60363 4.10355C6.79889 3.90829 6.79889 3.59171 6.60363 3.39645L6.21475 3.00757C7.77137 3.11767 9 4.41535 9 6C9 6.26891 8.96471 6.5294 8.89847 6.77717L9.68336 7.56206C9.88718 7.08201 10 6.55395 10 6C10 3.85866 8.31737 2.11031 6.20216 2.00502L6.60363 1.60355C6.79889 1.40829 6.79889 1.09171 6.60363 0.896447C6.40837 0.701184 6.09178 0.701184 5.89652 0.896447L4.64652 2.14645Z"
                        fill="#212121"
                      />
                      <path
                        d="M2.31663 4.43796C2.11283 4.91793 2 5.44593 2 6C2 8.14134 3.68263 9.88969 5.79784 9.99498L5.39637 10.3964C5.20111 10.5917 5.20111 10.9083 5.39637 11.1036C5.59163 11.2988 5.90822 11.2988 6.10348 11.1036L7.35348 9.85355C7.54874 9.65829 7.54874 9.34171 7.35348 9.14645L6.10348 7.89645C5.90822 7.70118 5.59163 7.70118 5.39637 7.89645C5.20111 8.09171 5.20111 8.40829 5.39637 8.60355L5.78525 8.99243C4.22863 8.88233 3 7.58465 3 6C3 5.73115 3.03529 5.47067 3.10153 5.22287L2.31663 4.43796Z"
                        fill="#212121"
                      />
                      <path d="M10.1464 10.8536C10.3417 11.0489 10.6583 11.0489 10.8536 10.8536C11.0488 10.6583 11.0488 10.3418 10.8536 10.1465L1.85355 1.14649C1.65829 0.951231 1.34171 0.951231 1.14645 1.14649C0.951184 1.34176 0.951185 1.65834 1.14645 1.8536L10.1464 10.8536Z" fill="#212121" />
                    </svg>
                  }
                  @if (!kausi.synkkausLukittu().value()) {
                    <svg class="sync-locked-icon" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000">
                      <g stroke-width="0"></g>
                      <g stroke-linecap="round" stroke-linejoin="round"></g>
                      <g>
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g fill="#212121" fill-rule="nonzero">
                            <path
                              d="M7.94822962,5.02850432 C8.2831456,5.46765091 8.19865,6.09515261 7.75950341,6.4300686 C6.03254452,7.74713709 5,9.78703304 5,12 C5,15.4973075 7.56475199,18.395585 10.9159977,18.9165744 L10.2071068,18.2071068 C9.81658249,17.8165825 9.81658249,17.1834175 10.2071068,16.7928932 C10.5976311,16.4023689 11.2307961,16.4023689 11.6213203,16.7928932 L14.1213203,19.2928932 C14.5118446,19.6834175 14.5118446,20.3165825 14.1213203,20.7071068 L11.6213203,23.2071068 C11.2307961,23.5976311 10.5976311,23.5976311 10.2071068,23.2071068 C9.81658249,22.8165825 9.81658249,22.1834175 10.2071068,21.7928932 L11.0502786,20.9504867 C6.52614758,20.4760098 3,16.6497928 3,12 C3,9.15643984 4.32881972,6.5312223 6.54666534,4.83977811 C6.98581193,4.50486213 7.61331363,4.58935773 7.94822962,5.02850432 Z M9.87867966,3.29289322 L12.3786797,0.792893219 C12.7692039,0.402368927 13.4023689,0.402368927 13.7928932,0.792893219 C14.1533772,1.15337718 14.1811067,1.72060824 13.8760818,2.11289944 L13.7928932,2.20710678 L12.9497214,3.0495133 C17.4738524,3.52399021 21,7.35020716 21,12 C21,14.7198329 19.7848559,17.243156 17.7284056,18.9418543 C17.3026041,19.2935809 16.6722931,19.2335313 16.3205666,18.8077299 C15.96884,18.3819284 16.0288896,17.7516174 16.454691,17.3998909 C18.0559569,16.0771906 19,14.1168256 19,12 C19,8.50269253 16.435248,5.60441498 13.0840023,5.08342564 L13.7928932,5.79289322 C14.1834175,6.18341751 14.1834175,6.81658249 13.7928932,7.20710678 C13.4324093,7.56759074 12.8651782,7.59532028 12.472887,7.29029539 L12.3786797,7.20710678 L9.87867966,4.70710678 C9.51819569,4.34662282 9.49046616,3.77939176 9.79549105,3.38710056 L9.87867966,3.29289322 L12.3786797,0.792893219 L9.87867966,3.29289322 Z"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                  }
                </button>
              </div>
              <!-- <div> -->
              <!-- [disabled]="hinta.get('hinta')?.disabled || 1 > i" -->
              <!-- [class.mat-elevation-z4]="!hinta.get('hinta')?.disabled" -->
              <!-- <button mat-icon-button (click)="poistaTilikausi(kausi)" type="button" style="padding:0;" class="secondarybutton mat-elevation-z4">
        <mat-icon>delete_forever</mat-icon>
      </button>
    </div> -->
            </div>
            @if (onkoVirhe(kausi, 'loppuEnnenAlkua')) {
              <mat-error> Alkupäivämäärä pitää olla ennen loppupäivää. </mat-error>
            }
          </div>
        }
        @if (onkoVirhe(lomake.tilikaudet, 'edellisenLoppu')) {
          <mat-error> Edellisen jakson on päätyttävä päivää ennen seuraavan alkamista. </mat-error>
        }
        @if (onkoVirhe(lomake.tilikaudet, 'min')) {
          <mat-error> Ole hyvä ja syötä vähintään yksi tilikausi. </mat-error>
        }
      </div>

      @if (newTilikausiPending()) {
        <div style="max-width: 550px">
          <div class="light-blue-text header">Lisää uusi tilikausi</div>
          <div>
            <div style="display: flex; justify-content: space-between; padding-top: 5px">
              <mat-form-field style="max-width: 125px; margin-right: 10px">
                <mat-label>Alkaa</mat-label>
                <input #tilikausiAlkaaInput type="text" [matDatepicker]="alkaaPicker" [formField]="uusiTilikausiLomake.alkaa" matInput data-lpignore="true" />
                <mat-datepicker-toggle matSuffix [for]="alkaaPicker"></mat-datepicker-toggle>
                @if (naytetaankoVirhe(uusiTilikausiLomake.alkaa, 'required')) {
                  <mat-error> Päivämäärä puuttuu </mat-error>
                }
                <mat-datepicker #alkaaPicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field style="max-width: 125px; margin-left: 10px; margin-right: 10px">
                <mat-label>Loppuu</mat-label>
                <input type="text" [matDatepicker]="loppuuPicker" [formField]="uusiTilikausiLomake.loppuu" matInput data-lpignore="true" />
                <mat-datepicker-toggle matSuffix [for]="loppuuPicker"></mat-datepicker-toggle>
                @if (naytetaankoVirhe(uusiTilikausiLomake.loppuu, 'required')) {
                  <mat-error> Päivämäärä puuttuu </mat-error>
                }
                <mat-datepicker #loppuuPicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field style="max-width: 160px; margin-left: 10px">
                <mat-label>Tilikartta</mat-label>
                <mat-select [formField]="uusiTilikausiLomake.tilikartanProfiili">
                  @for (profiili of kaikkiTilikartanProfiilit; track profiili) {
                    <mat-option [value]="profiili.tunnus">
                      {{ profiili.nimi }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            @if (onkoVirhe(uusiTilikausiLomake, 'loppuEnnenAlkua')) {
              <mat-error>Tilikauden alkupäivämäärä pitää olla ennen loppupäivää.</mat-error>
            }
            @if (onkoVirhe(uusiTilikausiLomake, 'paallekkainToisenTilikaudenKanssa')) {
              <mat-error>Lisättävä tilikausi ei saa olla päällekkäinen nykyisten tilikausien kanssa.</mat-error>
            }
          </div>

          <div style="text-align: right">
            <app-secondary-button (click)="setNewTilikausiPending(false)" actionId="Peruutettu tilikauden lisäys" additionalClass="mat-elevation-z4" style="margin-right: 20px"> Peruuta </app-secondary-button>
            <app-primary-button (click)="tallennaUusiTilikausi()" actionId="Avattu muokkausnäkymä: Vahvista uusi tilikausi" additionalClass="mat-elevation-z4"> Lisää </app-primary-button>
          </div>
        </div>
      } @else {
        <div style="padding-top: 10px; padding-bottom: 1.25em">
          <app-secondary-button (click)="luoUusiTilikausi()" actionId="Avattu muokkausnäkymä: Lisää tilikausi rivi" additionalClass="mat-elevation-z4" matIcon="add"> Lisää tilikausi </app-secondary-button>
        </div>
      }
    </div>

    <div class="light-blue-text header">Kirjanpidon peruste</div>
    <div class="content">
      <div style="max-width: 500px">
        @for (peruste of lomake.kirjanpidonPerusteet; track peruste; let i = $index) {
          <div>
            <div style="display: flex; justify-content: space-between; padding-top: 5px">
              <mat-form-field style="width: 200px; margin-right: 20px">
                <mat-select placeholder="Peruste" [formField]="peruste.peruste" style="width: 200px">
                  @for (peruste of kaikkiKirjanpidonPerusteet; track peruste) {
                    <mat-option [value]="peruste.tunnus">
                      {{ peruste.nimi }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field style="max-width: 125px; margin-right: 10px">
                <input monthPicker [matDatepicker]="perusteAlkaaPicker" [formField]="peruste.alkaa" placeholder="Alkaa" matInput data-lpignore="true" />
                <mat-datepicker-toggle matSuffix [for]="perusteAlkaaPicker"></mat-datepicker-toggle>
                <mat-datepicker #perusteAlkaaPicker></mat-datepicker>
                @if (naytetaankoVirhe(peruste.alkaa, 'loppuEnnenAlkua')) {
                  <mat-error> Pitää alkaa ennen loppua </mat-error>
                }
              </mat-form-field>
              <mat-form-field style="max-width: 125px; margin-left: 10px; margin-right: 10px">
                <!-- [min]="annaMinimiPaivamaara(hinta.get('voimassaAlkaen'))" -->
                <input monthPicker type="text" [matDatepicker]="perusteLoppuuPicker" [formField]="peruste.loppuu" placeholder="Loppuu" matInput data-lpignore="true" />
                <mat-datepicker-toggle matSuffix [for]="perusteLoppuuPicker"></mat-datepicker-toggle>
                @if (naytetaankoVirhe(peruste.loppuu, 'alkuLopunJalkeen')) {
                  <mat-error> Pitää loppua alun jälkeen </mat-error>
                }
                <mat-datepicker #perusteLoppuuPicker></mat-datepicker>
              </mat-form-field>
            </div>
            @if (naytetaankoVirhe(peruste, 'loppuEnnenAlkua')) {
              <mat-error> Alkupäivämäärä pitää olla ennen loppupäivää. </mat-error>
            }
          </div>
        }

        @if (naytetaankoVirhe(lomake.kirjanpidonPerusteet, 'edellisenLoppu')) {
          <mat-error> Edellisen jakson on päätyttävä päivää ennen seuraavan alkamista. </mat-error>
        }
        @if (naytetaankoVirhe(lomake.kirjanpidonPerusteet, 'samaPeruste')) {
          <mat-error> Peräkkäisillä jaksoilla on oltava eri peruste. </mat-error>
        }
      </div>

      <div style="padding-top: 10px; padding-bottom: 1.25em">
        <app-secondary-button (click)="lisaaKirjanpidonPeruste()" actionId="Avattu muokkausnäkymä: Lisää kirjanpidon peruste rivi" additionalClass="mat-elevation-z4" matIcon="add"> Lisää peruste </app-secondary-button>
      </div>
    </div>

    @if (onkoDevaajaObservable | async) {
      <div class="light-blue-text header">1777-selvittely lukituilla kuukausilla</div>
      <div class="dark-gray-text" style="font-style: italic; font-size: 11px; margin-bottom: 10px">*vain kehittäjät</div>
      <div class="content">
        <mat-checkbox [formField]="lomake.selvittelyLukituillaKkKaytossa">Käytössä</mat-checkbox>
      </div>
    }

    <div class="light-blue-text header">Automaattinen omaverotäsmäytys</div>
    <div class="content">
      <div style="display: flex; justify-content: space-between; width: 18em">
        <div>Tilikausi</div>
        <div>Päällä</div>
      </div>
      <div>
        @for (tasmaytysTilikausi of lomake.tasmaytysTilikaudet; track tasmaytysTilikausi; let i = $index) {
          <div style="display: flex; justify-content: space-between; align-items: center; width: 17em">
            <div>{{ tasmaytysTilikausi.tilikaudenJakso().value() }}</div>
            <mat-checkbox [formField]="tasmaytysTilikausi.tasmaytysAktiivinen"> </mat-checkbox>
          </div>
        }
        <div style="margin-top: 2em; font-style: italic; max-width: 800px">
          Jos automaattinen omaverotäsmäytys otetaan pois päältä, kyseisen tilikauden omaverokirjaukset poistetaan seuraavassa automaattiajossa (seuraavana yönä). Jos se laitetaan takaisin päälle, omaverokirjaukset tehdään seuraavan automaattiajon yhteydessä (seuraavana yönä). Omaveroautomatiikka ajetaan vain avoimien tilikausien aktiivisille kuukausille.
        </div>
      </div>
    </div>

    <div class="light-blue-text header">Tilikauden vaihteen automaattikirjaukset</div>
    <div class="content">
      <div style="font-style: italic; max-width: 800px; margin-bottom: 1em">
        Kirjaukset "Edellisen tilikauden tulos" ja "Yksityistilin tyhjentäminen" muodostetaan automaattisesti tilikauden päättyessä seuraavan tilikauden ensimmäiselle päivälle. Jos muodostus otetaan tilikaudelta pois, jo tehdyt kirjaukset poistetaan seuraavassa automaattiajossa. Alkusaldojen tuonti ottaa muodostuksen pois niiltä tuoduilta tilikausilta, joiden vaihdekirjaukset sisältyvät tuotuun
        aineistoon.
      </div>
      <div style="display: flex; justify-content: space-between; width: 18em">
        <div>Tilikausi</div>
        <div>Muodostetaan</div>
      </div>
      <div>
        @for (vaihdekirjausTilikausi of lomake.vaihdekirjausTilikaudet; track vaihdekirjausTilikausi; let i = $index) {
          <div style="display: flex; justify-content: space-between; align-items: center; width: 17em">
            <div>{{ vaihdekirjausTilikausi.tilikaudenJakso().value() }}</div>
            <mat-checkbox [formField]="vaihdekirjausTilikausi.kirjauksetMuodostetaan"> </mat-checkbox>
          </div>
        }
      </div>
    </div>

    @if (naytaSuperObservable | async) {
      <div style="padding: 20px; margin-top: 20px" class="mat-elevation-z3">
        <div class="dark-gray-text" style="font-style: italic; line-height: 30px">* Lomakkeen tiedot näkyvät vain pääkäyttäjä-roolilla</div>
        <mat-checkbox [checked]="naytaPoistuneetKirjanpitajatSubject | async" (change)="toggleNaytaPoistuneetKirjanpitajat()" style="vertical-align: middle; transform: scale(0.7); transform-origin: left center"> Näytä myös poistuneet kirjanpitajat alasvetovalikoissa </mat-checkbox>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 10px">
          <div class="light-blue-text header" style="margin: 0">Vastuukirjanpitäjät</div>
        </div>
        <div class="content">
          @if (asiakas?.siirrettyJakolistalta) {
            <div class="myynnin-jakolistalla">
              <div class="jakolistalla-title light-blue-text">Myynnin jakolistalla</div>

              <div class="jakolistalla-content">
                @if (salesJakso()) {
                  <div class="kirjanpitaja-rivi nykyinen-kirjanpitaja-rivi">
                    <mat-form-field class="kirjanpitaja-valinta">
                      <mat-label>Vastuukirjanpitäjä</mat-label>
                      <mat-select [formField]="salesKirjanpitaja">
                        @for (kirjanpitaja of kirjanpitajatObservable | async; track kirjanpitaja) {
                          <mat-option [value]="kirjanpitaja.avain"> {{ kirjanpitaja.etunimi }} {{ kirjanpitaja.sukunimi }} </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field class="form-field-small">
                      <mat-label>Voimassa alkaen</mat-label>
                      <input matInput disabled [value]="asiakas.kirjanpitajat[0].voimassaoloAlkaa | lokaalipvm | async" />
                    </mat-form-field>
                  </div>
                }
                <div class="jakolistalla-detail-row">Myynti luonut asiakkaan: {{ asiakas?.siirrettyJakolistalta?.salesAlkaa | lokaalipvm | async }}</div>
                @if (asiakas?.siirrettyJakolistalta?.siirtoPaiva) {
                  <div>Siirretty ensimmäiselle kirjanpitäjälle: {{ asiakas?.siirrettyJakolistalta?.siirtoPaiva | lokaalipvm | async }}</div>
                }
              </div>
            </div>
          }

          @if (salesJakso()) {
            <div class="ensimmaisen-vastuukirjanpitajan-lisays">
              <div class="ensimmaisen-kp-title light-blue-text">Ensimmäisen vastuukirjanpitäjän lisäys</div>

              <div class="ensimmaisen-kp-description">
                Vaihda asiakkaan ensimmäinen oikea vastuukirjanpitäjä:
                <ul class="list-items-spacing">
                  <li>Vastuukirjanpitäjä asetetaan asiakkaalle</li>
                  <li>Siirtopäivämäärä tallennetaan "myynnin jakolistalla" osioon</li>
                  <li>Laskujen tilastot vaihdetaan myynniltä uudelle kirjanpitäjälle ja nykyiselle tiimille</li>
                </ul>
              </div>

              <div style="max-width: 450px">
                <div>
                  <div class="kirjanpitaja-rivi">
                    <mat-form-field class="kirjanpitaja-valinta">
                      <mat-label>Kirjanpitäjä</mat-label>
                      <mat-select [formField]="salesListaltaKirjanpitajalle.kirjanpitaja">
                        @for (kirjanpitaja of kirjanpitajatObservable | async; track kirjanpitaja) {
                          <mat-option [value]="kirjanpitaja.avain"> {{ kirjanpitaja.etunimi }} {{ kirjanpitaja.sukunimi }} </mat-option>
                        }
                      </mat-select>
                      @if (onkoVirhe(salesListaltaKirjanpitajalle.kirjanpitaja, 'required')) {
                        <mat-error> Kirjanpitäjä vaaditaan </mat-error>
                      }
                    </mat-form-field>

                    <div class="voimassa-info-rivi">
                      <mat-form-field class="form-field-small">
                        <mat-label>Voimassa alkaen</mat-label>
                        <input type="text" [min]="kirjanpitajaAlkaaMin()" [max]="kirjanpitajaAlkaaMax()" [matDatepicker]="kirjanpitajaVoimassaPicker" [formField]="salesListaltaKirjanpitajalle.voimassaoloAlkaa" matInput data-lpignore="true" />
                        <mat-datepicker-toggle matSuffix [for]="kirjanpitajaVoimassaPicker"></mat-datepicker-toggle>
                        @if (naytetaankoVirhe(salesListaltaKirjanpitajalle.voimassaoloAlkaa, 'required')) {
                          <mat-error> Päivämäärä puuttuu </mat-error>
                        }
                        @if (onkoVirhe(salesListaltaKirjanpitajalle.voimassaoloAlkaa, 'matDatepickerMin')) {
                          <mat-error> Aloitus ei voi olla ennen kuluvaa kuukautta </mat-error>
                        }
                        @if (onkoVirhe(salesListaltaKirjanpitajalle.voimassaoloAlkaa, 'matDatepickerMax')) {
                          <mat-error> Kirjanpitäjyyden on alettava viimeistään laskutuksen alkamiskuukautena </mat-error>
                        }
                        @if (onkoVirhe(salesListaltaKirjanpitajalle.voimassaoloAlkaa, 'eiKuukaudenAlku')) {
                          <mat-error> Valitse kuukauden ensimmäinen päivä </mat-error>
                        }
                        <mat-datepicker #kirjanpitajaVoimassaPicker startView="year" (monthSelected)="valitseKirjanpitajanAlkukuukausi($event, kirjanpitajaVoimassaPicker, salesListaltaKirjanpitajalle)"></mat-datepicker>
                      </mat-form-field>
                      <span class="info-icon-wrapper">
                        <mat-icon class="info-icon">info_outline</mat-icon>
                        <span class="custom-tooltip">
                          <strong>Alkamiskuukausi</strong><br />
                          Viimeistään laskutuksen alkamiskuukausi - tai mikä tahansa sitä aiempi. Oletuksena kuluva kuukausi. Jos haluat aloituksen myöhemmäksi, muuta asiakkaan hintaa. Aloitus on aina kuukauden ensimmäinen päivä.
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div style="margin-top: 20px">
                <app-primary-button [disabled]="onkoSiirtoEstetty || onkoEnsimmaisenKirjanpitajanAlkuVirheellinen" (click)="tallennaEnsimmainenOikeaVastuukirjanpitaja()" actionId="Tallenna ensimmäinen vastuukirjanpitäjä ja vaihda laskutilastot" additionalClass="mat-elevation-z4" styles="background-color: #20c997; color: white;"> Tallenna ja vaihda laskutilastot </app-primary-button>
              </div>
            </div>
          }

          @if (!salesJakso()) {
            <div style="max-width: 400px">
              @for (jakso of lomake.voimassaolojaksot; track jakso; let i = $index) {
                <div>
                  <div style="display: flex; justify-content: space-between">
                    <mat-form-field>
                      <mat-label>Kirjanpitäjä</mat-label>
                      <mat-select #kirjanpitajaSelect [formField]="jakso.kirjanpitaja">
                        <!-- <mat-option [value]="eiKirjanpitajaaAvain">
                  Ei kirjanpitäjää
                </mat-option> -->
                        @for (kirjanpitaja of kirjanpitajatObservable | async; track kirjanpitaja) {
                          <mat-option [value]="kirjanpitaja.avain"> {{ kirjanpitaja.etunimi }} {{ kirjanpitaja.sukunimi }} </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <!-- [min]="annaMinimiPaivamaara(jakso.get('voimassaoloAlkaa'))" -->
                    <mat-form-field style="max-width: 150px; margin-left: 10px; margin-right: 10px">
                      <mat-label>Voimassa alkaen</mat-label>
                      <input type="text" [matDatepicker]="kirjanpitajaVoimassaPicker" [formField]="jakso.voimassaoloAlkaa" matInput data-lpignore="true" />
                      <mat-datepicker-toggle matSuffix [for]="kirjanpitajaVoimassaPicker"></mat-datepicker-toggle>
                      @if (naytetaankoVirhe(jakso.voimassaoloAlkaa, 'required')) {
                        <mat-error> Päivämäärä puuttuu </mat-error>
                      }
                      @if (naytetaankoVirhe(jakso.voimassaoloAlkaa, 'edellinen')) {
                        <mat-error> Muutos ei voi olla samaan aikaan tai ennen edellistä jaksoa. </mat-error>
                      }
                      <!-- <mat-error *ngIf="jakso.get('voimassaoloAlkaa')?.errors?.min && (jakso.get('voimassaoloAlkaa')?.dirty || jakso.get('voimassaoloAlkaa')?.touched)">
              Uusi muutos voi alkaa aikaisintaan ensi kuussa.
            </mat-error>
            <mat-error *ngIf="jakso.get('voimassaoloAlkaa')?.errors?.matDatepickerMin && (voimassaAlkaen?.dirty || voimassaAlkaen?.touched)">
              Uusi muutos voi alkaa aikaisintaan ensi kuussa.
            </mat-error> -->
                      <mat-datepicker #kirjanpitajaVoimassaPicker></mat-datepicker>
                    </mat-form-field>
                    <app-icon-button [disabled]="jakso.voimassaoloAlkaa().disabled() || 1 > i" (click)="poistaKirjanpitajanVoimassaolojakso(jakso)" [dynamicClass]="{ 'mat-elevation-z4': !jakso.voimassaoloAlkaa().disabled() }" actionId="Poista kirjanpitäjän voimassaolojakso" additionalClass="secondarybutton" styles="padding:0;" matIcon="delete_forever"> </app-icon-button>
                  </div>
                </div>
              }
            </div>
            @if (naytetaankoVirhe(lomake.voimassaolojaksot, 'min')) {
              <mat-error style="margin-left: 10px"> Ole hyvä ja syötä vähintään yksi jakso. </mat-error>
            }
            <div style="padding-top: 10px; margin-left: 10px; padding-bottom: 1.25em">
              <app-secondary-button (click)="lisaaKirjanpitajanVoimassaolojakso()" actionId="Avattu muokkausnäkymä: Lisää vastuukirjanpitojakso rivi" additionalClass="mat-elevation-z4" matIcon="add"> Lisää vastuukirjanpitojakso </app-secondary-button>
            </div>
          }
        </div>
        <div class="light-blue-text header">Varakirjanpitäjät</div>
        <div class="content">
          <div style="max-width: 400px">
            @for (jakso of lomake.voimassaolojaksotvara; track jakso; let i = $index) {
              <div>
                <div style="display: flex; justify-content: space-between">
                  <mat-form-field>
                    <mat-label>Varakirjanpitäjä</mat-label>
                    <mat-select #varakirjanpitajaSelect [formField]="jakso.kirjanpitaja">
                      <mat-option [value]="eiKirjanpitajaaAvain"> Ei kirjanpitäjää </mat-option>
                      @for (kirjanpitaja of kirjanpitajatObservable | async; track kirjanpitaja) {
                        <mat-option [value]="kirjanpitaja.avain"> {{ kirjanpitaja.etunimi }} {{ kirjanpitaja.sukunimi }} </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <!-- [min]="annaMinimiPaivamaara(jakso.get('voimassaoloAlkaa'))" -->
                  <mat-form-field style="max-width: 150px; margin-left: 10px; margin-right: 10px">
                    <mat-label>Voimassa alkaen</mat-label>
                    <input type="text" [matDatepicker]="varaKirjanpitajaVoimassaPicker" [formField]="jakso.voimassaoloAlkaa" matInput data-lpignore="true" />
                    <mat-datepicker-toggle matSuffix [for]="varaKirjanpitajaVoimassaPicker"></mat-datepicker-toggle>
                    @if (naytetaankoVirhe(jakso.voimassaoloAlkaa, 'required')) {
                      <mat-error> Päivämäärä puuttuu </mat-error>
                    }
                    @if (naytetaankoVirhe(jakso.voimassaoloAlkaa, 'edellinen')) {
                      <mat-error> Muutos ei voi olla samaan aikaan tai ennen edellistä jaksoa. </mat-error>
                    }
                    <!-- <mat-error *ngIf="jakso.get('voimassaoloAlkaa')?.errors?.min && (jakso.get('voimassaoloAlkaa')?.dirty || jakso.get('voimassaoloAlkaa')?.touched)">
            Uusi muutos voi alkaa aikaisintaan ensi kuussa.
          </mat-error>
          <mat-error *ngIf="jakso.get('voimassaoloAlkaa')?.errors?.matDatepickerMin && (voimassaAlkaen?.dirty || voimassaAlkaen?.touched)">
            Uusi muutos voi alkaa aikaisintaan ensi kuussa.
          </mat-error> -->
                    <mat-datepicker #varaKirjanpitajaVoimassaPicker></mat-datepicker>
                  </mat-form-field>
                  <app-icon-button [disabled]="jakso.voimassaoloAlkaa().disabled()" (click)="poistaKirjanpitajanVoimassaolojaksovara(jakso)" [dynamicClass]="{ 'mat-elevation-z4': !jakso.voimassaoloAlkaa().disabled() }" actionId="Poista varakirjanpitäjän voimassaolojakso" additionalClass="secondarybutton" styles="padding:0;" matIcon="delete_forever"> </app-icon-button>
                </div>
              </div>
            }
          </div>
          <!-- <mat-error *ngIf="annaKirjanpitajienVoimassaolojaksotFormArray()?.errors?.min && (annaKirjanpitajienVoimassaolojaksotFormArray()?.dirty || annaKirjanpitajienVoimassaolojaksotFormArray()?.touched)" style="margin-left: 10px;">
Ole hyvä ja syötä vähintään yksi jakso.
</mat-error> -->
          <div style="padding-top: 10px; margin-left: 10px; padding-bottom: 1.25em">
            <app-secondary-button (click)="lisaaKirjanpitajanVoimassaolojaksovara()" actionId="Avattu muokkausnäkymä: Lisää varakirjanpitojakso rivi" additionalClass="mat-elevation-z4" matIcon="add"> Lisää varakirjanpitojakso </app-secondary-button>
          </div>
        </div>
        @if (onkoDevaajaObservable | async) {
          <div class="light-blue-text header">Kirjanpidon tyyppi</div>
          <div class="content">
            <div style="max-width: 340px">
              @for (tyyppi of lomake.kirjanpidonTyypit; track tyyppi; let i = $index) {
                <div>
                  <div style="display: flex; justify-content: space-between; padding-top: 5px">
                    <mat-form-field style="width: 250px; margin-right: 20px">
                      <mat-label>Tyyppi</mat-label>
                      <mat-select [formField]="tyyppi.tyyppi">
                        @for (tyyppiVaihtoehto of kaikkiKirjanpidonTyypit; track tyyppiVaihtoehto) {
                          <mat-option [value]="tyyppiVaihtoehto.tunnus">
                            {{ tyyppiVaihtoehto.nimi }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field style="max-width: 125px; margin-right: 10px">
                      <mat-label>Alkaa</mat-label>
                      <input type="text" [matDatepicker]="tyyppiAlkaaPicker" [formField]="tyyppi.alkaa" matInput data-lpignore="true" />
                      <mat-datepicker-toggle matSuffix [for]="tyyppiAlkaaPicker"></mat-datepicker-toggle>
                      <mat-datepicker #tyyppiAlkaaPicker></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field style="max-width: 125px; margin-left: 10px; margin-right: 10px">
                      <mat-label>Loppuu</mat-label>
                      <input type="text" [matDatepicker]="tyyppiLoppuuPicker" [formField]="tyyppi.loppuu" matInput data-lpignore="true" />
                      <mat-datepicker-toggle matSuffix [for]="tyyppiLoppuuPicker"></mat-datepicker-toggle>
                      <mat-datepicker #tyyppiLoppuuPicker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              }
            </div>
            <div style="padding-top: 10px; margin-left: 10px; padding-bottom: 1.25em">
              <app-secondary-button (click)="lisaaKirjanpidonTyyppi()" actionId="Avattu muokkausnäkymä: Lisää kirjanpidon tyyppi rivi" additionalClass="mat-elevation-z4" matIcon="add"> Lisää kirjanpidon tyyppi </app-secondary-button>
            </div>
          </div>
        }
        <div class="light-blue-text header">Käynnistä Omaverotäsmäytys</div>
        <div class="content">
          @if (naytaOmaveroTasmaytysObservable | async) {
            <form>
              <div style="max-width: 400px">
                <mat-form-field>
                  <mat-label>Tilikausi</mat-label>
                  <mat-select #kirjanpitajaSelect [formField]="omaveroLomake.omaveroTilikausi">
                    @for (tilikausi of omaveroTilikaudetObservable | async; track tilikausi) {
                      <mat-option [value]="tilikausi.avain"> {{ tilikausi.alkaa | lokaalipvm | async }} - {{ tilikausi.loppuu | lokaalipvm | async }} </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              @if (omaverotasmaytysError) {
                <div style="padding-bottom: 1em" class="error-text">{{ omaverotasmaytysError }}</div>
              }
              <div style="padding-top: 10px; margin-left: 10px; padding-bottom: 1.25em">
                <app-primary-button (click)="kaynnistaOmaverotasmaytys()" actionId="Käynnistä Omaverotäsmäytys tilikaudelle" [actionContext]="[omaveroLomake().value()]" additionalClass="mat-elevation-z4"> Käynnistä Omaverotäsmäytys tilikaudelle </app-primary-button>
              </div>
            </form>
          } @else {
            <div style="max-width: 400px">Omaverotäsmäytys ei ole käytössä tälle yritykselle.</div>
          }
        </div>
      </div>
    }

    <div style="display: flex; justify-content: space-evenly; padding-top: 40px; padding-bottom: 2em; max-width: 500px">
      <app-primary-button (click)="save()" actionId="Tallenna kirjanpitotiedot" [actionContext]="[lomake().value()]" styles="padding: 0 18px;">
        {{ 'yleiset.tallenna' | translate | async }}
      </app-primary-button>
    </div>
  </form>
</div>
